import { createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/features/auth/guards'

export const Route = createFileRoute('/_authed/trash')({
  beforeLoad: requireRole('ROLE_SUPER_ADMIN'),
  component: () => <h1 className="text-2xl font-semibold">Trash</h1>,
})
